export default __webpack_public_path__ + "static/media/391.0a9ebe9a.png";